import React from 'react'
import dynamic from 'next/dynamic'

import { Button } from '@thg-commerce/gravity-elements'
import { spacing, styled } from '@thg-commerce/gravity-theme'

const InfoIcon = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/hangerIcon'),
  { ssr: true, loading: () => <div style={{ width: 24, height: 24 }} /> },
)

export const HullabalookButton = styled(Button)`
  margin-bottom: 8px;
  width: '100px';
`

export const StyledHangerIcon = styled(InfoIcon)`
  path:first-of-type {
    fill: ${(props) => props.theme.colors.palette.brand.dark};
  }
  margin-right: ${spacing(1)};
  ${HullabalookButton}:hover & {
    path:first-of-type {
      fill: ${(props) => props.theme.colors.palette.greys.white};
    }
  }
  ${HullabalookButton}:active & {
    path:first-of-type {
      fill: ${(props) => props.theme.colors.palette.greys.white};
    }
  }
`
export default HullabalookButton
